import { Action, createReducer, on } from '@ngrx/store';
import { AppSettings } from 'src/app/modules/shared/model/appSettings.model';
import { loadAppSettings, addAppSettings, loadAppSettingsSuccess, addAppSettingsSuccess } from '../actions/app-settings.actions';


export const appSettingsFeatureKey = 'appSettings';

export interface State{
}

export const initialState: State = {
  AdminMode: false,
  embedMode: false,
  licenseRequiredForRegistration: null,
  licenseRequiredForRegistrationSet: false
};


export const appSettingsReducer = createReducer(
  initialState,
  on(loadAppSettings, (state, newState) => (newState)),
  on(loadAppSettingsSuccess, (state, newState) => (newState)),
  on(addAppSettings, (state, newState) => ({
      ...newState
    })),
  on(addAppSettingsSuccess, (state, newState) => (newState)),
  );
